import { CollapsibleTooltipCell } from '@app/components/various/Table/Cells/CollapsibleTooltipCell';
import { compiledPaths } from '@app/paths';
import { Cms } from '@typings';
import { Link } from 'react-router-dom';

import { PreviouslyTableCell } from '../PreviouslyTableCell/PreviouslyTableCell';

interface Props {
  text: string;
  row: Cms.Page;
}

export const TitleCell = ({ text, row }: Props) => (
  <Link className="table-row-interaction max-w-60 overflow-hidden" to={compiledPaths.CMS_EDITOR({ pageId: row.id })}>
    <PreviouslyTableCell property="name" page={row}>
      <CollapsibleTooltipCell className="z-interactiveTableItem">{text}</CollapsibleTooltipCell>
    </PreviouslyTableCell>
  </Link>
);
